// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const commisionSplitter = '^*^'
export const commisionSplitterArr = /\^\*\^/g